export const colors: Record<number, string> = {
  0: '#440154',
  1: '#472c7a',
  2: '#3b518b',
  3: '#2c728e',
  4: '#21918c',
  5: '#27ad81',
  6: '#5cc863',
  7: '#aadc32',
  8: '#fde725',
  9: '#46337E',
  10: '#365C8D',
  11: '#277F8E',
  12: '#1EA187',
  13: '#4AC16D',
  14: '#9FDA3A',
  15: '#86d549',
  16: '#5ec962',
  17: '#3dbc74',
  18: '#1fa187',
  19: '#2a788e',
  20: '#33638d',
  21: '#3f4889',
  22: '#482878',
  23: '#440154',
  24: '#48186a',
  25: '#453781',
  26: '#39568c',
  27: '#2d708e',
  28: '#238a8d',
  29: '#1f968b',
};

export const getColor = (index: number) => colors[index % Object.keys(colors).length];

export function generateComponentColorMap(chartData: any[]): Record<string, string> {
  const map: Record<string, string> = {};
  const seen = new Set<string>();
  let colorIndex = 0;

  chartData?.forEach((entry) => {
    entry.names.forEach((name: string) => {
      if (!seen.has(name)) {
        map[name] = getColor(colorIndex++);
        seen.add(name);
      }
    });
  });

  return map;
}
